module.exports = __webpack_public_path__ + "static/media/1.95e3a09d.png";